export default __webpack_public_path__ + "static/quedemy-text-logo-rect-white-6b7ad6f85684329cc474cf4393ec813d.png";